<form [formGroup]="form">
  <div class="gap-sm grid" formArrayName="trigrammesType">
    @for (form of trigrammesType.controls; track $index; let idx = $index) {
      <app-expansion-panel
        [titre]="'Trigramme type de certification ' + (idx + 1)"
        [item]="idx"
        [isOpen]="true"
        [actions]="trigrammeActions"
      >
        <div class="gap-lg p-lg grid" [formGroupName]="idx">
          <div hlmField>
            <label [for]="'nom-' + idx" hlmFieldLabel labelRequired>Nom</label>
            <input [id]="'nom-' + idx" hlmInput type="text" formControlName="nom" />
            @if (form.get('nom')?.invalid && form.get('nom')?.touched) {
              <hlm-field-error>Le nom doit être renseigné.</hlm-field-error>
            }
          </div>
          <div hlmField>
            <label [for]="'code-' + idx" hlmFieldLabel labelRequired>Trigramme</label>
            <input [id]="'code-' + idx" hlmInput type="text" formControlName="code" />
            @if (form.get('code')?.invalid && form.get('code')?.touched) {
              <hlm-field-error>Le code doit être composé de 3 lettres en majuscule.</hlm-field-error>
            }
          </div>
        </div>
      </app-expansion-panel>
    }
    @if (!trigrammeType()) {
      <app-button-add-new (click)="ajouterTrigrammeType()" label="Ajouter un autre trigramme" />
    }
  </div>
</form>
